export { LyCheckboxModule, LyCheckboxService, LY_CHECKBOX_CONTROL_VALUE_ACCESSOR, CheckboxState, LyCheckbox } from './ly-checkbox.module';



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/checkbox/index.js
// module id = 1346
// module chunks = 31